import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  Signal
} from '@angular/core';
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: 'soph-pager',
  standalone: true,
  imports: [
    MatIcon
  ],
  templateUrl: './pager.component.html',
  styleUrl: './pager.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PagerComponent {

  public currentPage: InputSignal< number > = input<number>( 1 );
  public totalElements: InputSignal< number > = input<number>( 1 );
  public pageSize: InputSignal< number > = input<number>( 12 );

  public totalPages: Signal< number > = computed(() => Math.ceil( this.totalElements() / this.pageSize() ));
  public isFirstPage: Signal< boolean > = computed(() => this.currentPage() === 1);
  public isLastPage: Signal< boolean > = computed(() => this.currentPage() === this.totalPages());
  public pages: Signal<number[]> = computed( () => {
    const total = this.totalPages();
    const current = this.currentPage();

    const start = Math.max(1, current - 4);
    const end = Math.min(total, current + 4);

    const length = end - start + 1;
    return Array.from({ length }, (_, i) => start + i );
  });

  public onUpdatePage: OutputEmitterRef<number> = output<number>();

  public onPreviousPageClick() {
    if ( !this.isFirstPage() ) {
      this.onUpdatePage.emit( this.currentPage() - 1 );
    }
  }

  public onNextPageClick() {
    if ( !this.isLastPage() ) {
      this.onUpdatePage.emit( this.currentPage() + 1 );
    }
  }

  public onPageClick( page: number ) {
    if ( page !== this.currentPage() ) this.onUpdatePage.emit( page );
  }

}
